import React from 'react';
import { ViewerPageProps } from './types';
import { ArcStack, ArcText } from '@src/core/ui';
import { ArcBaseContent, ArcBaseSidebar } from '@src/core/components';
import { EnRouteOrders } from './components';

const ViewerPage: React.FC<ViewerPageProps> = () => {
  return (
    <ArcStack direction='row'>
      <ArcBaseSidebar>
        <ArcText.h4 marginTop={2}> Viewer Mode </ArcText.h4>
        
        <ArcText.h5 color="text.secondary" marginTop={1.5}>
Monitor active drone operations
        </ArcText.h5>
        <ArcStack spacing={3} marginTop={2.5}>
        
          <ArcStack spacing={2}>
            <ArcText.h6> EN ROUTE  </ArcText.h6>
            <EnRouteOrders />
          </ArcStack>
        </ArcStack>
      </ArcBaseSidebar>

      <ArcBaseContent />
    </ArcStack>
  );
};

export default ViewerPage;